// neurotrader-admin/src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/authService'; // Garanta que este serviço exista

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        try {
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                const userData = JSON.parse(storedUser);
                // Lógica de verificação de expiração VIP (se aplicável no admin)
                if (userData.subscription_expires_at) {
                    const expirationDate = new Date(userData.subscription_expires_at);
                    if (expirationDate < new Date()) {
                        userData.is_vip = false;
                    }
                }
                setUser(userData);
            }
        } catch (error) {
            console.error("Falha ao carregar usuário do localStorage", error);
            localStorage.removeItem('user'); // Limpa dados corrompidos
        } finally {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        // O authService.login já salva a resposta da API no localStorage
        const userData = await authService.login(email, password);
        setUser(userData); // O estado 'user' agora contém a resposta "plana"
    };

    const logout = () => {
        authService.logout();
        setUser(null);
    };

    // --- CORREÇÃO PRINCIPAL AQUI ---
    // O objeto 'value' agora lê as propriedades diretamente do estado 'user',
    // pois não há mais um objeto 'user' aninhado.
    const value = {
        user, // Contém o objeto completo: { token, email, is_admin, ... }
        isAuthenticated: !!user,
        isAdmin: !!user?.is_admin, // Acessa 'is_admin' diretamente
        isVip: !!user?.is_vip,       // Acessa 'is_vip' diretamente
        loading,
        login,
        logout,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};